import { $translate } from '@/utils/i18n';
export default {
    imageType: [
        {
            label: $translate('lang.E3202103010004', { defaultText: '文本' }),
            value: '0'
        },
        {
            label: $translate('lang.E3202103010005', { defaultText: '数字' }),
            value: '1'
        },
        {
            label: $translate('lang.E3202103010006', { defaultText: '视频' }),
            value: '3'
        },
        {
            label: $translate('lang.E3202103010007', { defaultText: '图片' }),
            value: '2'
        }
    ],
    enhanceDeal: [
        {
            label: $translate('lang.E3202102230001', { defaultText: '是' }),
            value: 'Y'
        },
        {
            label: $translate('lang.E3202102230002', { defaultText: '否' }),
            value: 'N'
        }
    ]
};